
import { useLocate } from '../hooks'


const LocateButton = ({ mapId }) => {
  const locate = useLocate(mapId)

  return (
    <button className="map--gps" onClick={locate}><img src="images/gps-icon.svg" alt="GPS icon" /></button>
  )
}

export default LocateButton